module.exports = __webpack_public_path__ + "prod/20260406190927/img/url-app.d88da72d.png";